<template lang="pug">
 v-container
    v-row(justify="center")
        v-col(cols="12")
            v-card
                v-card-title Information
                v-card-text This webapp is the attempt of implementing the driver model described in Boda et al. (2019)[submitted]. The driver model predicts driver braking behaviour when a cyclist crosses their travel path. The driver model used the modelling framework developed by Markkula et al. (2018).
                v-spacer
                v-card-text
                    DriverModeSVG
                v-spacer

                v-card-text The simulation parameters can be changed by clicking on the icons at the top-right of your screen (i.e., car, bicycle, ...). You can then visualise the #[router-link(to="/chart") signals] or play the #[router-link(to="/animation") animation]).

</template>
<script>
import DriverModeSVG from "@/assets/svg/driverModel.svg";

export default { components: { DriverModeSVG } };
</script>
<style scoped>
</style>
